var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"titulo-aba"},[_vm._v("Comparativo de dados")]),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.itens,"item-key":"id"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }